import React from 'react';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectDefaultTheme } from 'GeminiViewerComponent/features/globals/themeSlice';
import { useStyles } from './styles';

const AppButton = ({ text, style, children, variant, className, handleButtonClick }) => {
    const theme = useSelector(selectDefaultTheme);
    const classes = useStyles(theme);
    return (
        <Button
            variant={variant}
            disableElevation
            className={classes[className]}
            style={style}
            onClick={handleButtonClick}
        >
            {text}
            {children}
        </Button>
    );
};

export default AppButton;
